import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Tänään',
    asap: 'Mahdollisimman pian',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Huoneen numero',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Pöydän numero',
  },
};
